module.exports = __webpack_public_path__ + "a8a10a3e/img/lock-icon.bb9c7166.svg";